import { ListType } from 'modules/domains/list';
import { ActionMenuOption } from 'ui/actionMenu/types';
import { useAddUsersOrModifyListLink } from './useAddUsersOrModifyListLink';
import { useRemoveUsersLink } from './useRemoveUsersLink';
import { useSignupFormLink } from './useSignupFormLink';
import { useDeleteListsButton } from './useDeleteListsButton';
import { List } from '../../../types';

export const useRowOverflowMenu = (list: List): ActionMenuOption[] => {
  const addUsersOrModifyListLink = useAddUsersOrModifyListLink(list);
  const removeUsersLink = useRemoveUsersLink(list);
  const signupFormLink = useSignupFormLink(list);
  const deleteListsButton = useDeleteListsButton(list);

  // Dynamic lists only have delete as an option
  if (list.listType === ListType.Dynamic) return [deleteListsButton];

  return [addUsersOrModifyListLink, removeUsersLink, signupFormLink, deleteListsButton];
};
